import { createEvent, createCustomEvent } from './create-event';
import isEditMode from './detect-edit-mode';
import isIe from './detect-ie';
import isMicrosoft from './detect-microsoft';
import isMobile from './detect-mobile';
import toArray from './get-elements-array';
import leadZero from './lead-zero';
import Lerper from './Lerper';
import loadFonts from './load-fonts';
import resizeCover from './resizeCover';
import scrollBarWidth from './scroll-bar-width';
import toggleBodyScroll from './toggle-body-scroll';
import toggleModal from './toggle-modal';
import Nearby from './Nearby';
import HoverLetterSpacing from './HoverLetterSpacing';
import transitionend from './transitionend';

export * from './Nearby';

export {
  createEvent,
  createCustomEvent,
  isMobile,
  isIe,
  isMicrosoft,
  isEditMode,
  toggleBodyScroll,
  toggleModal,
  toArray,
  leadZero,
  Lerper,
  loadFonts,
  resizeCover,
  scrollBarWidth,
  transitionend,
  Nearby,
  HoverLetterSpacing,
};



// WEBPACK FOOTER //
// ./scripts/utils/index.js